import { render, staticRenderFns } from "./CompPaginacao.vue?vue&type=template&id=3fcb84e4&"
import script from "./CompPaginacao.vue?vue&type=script&lang=js&"
export * from "./CompPaginacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports